import tags from "./tags.component";
import tagsUrls from "./tags.urls";
import TagsTransforms from "./tags.transforms";

const tagsModule = angular
  .module("app.components.tags", [])
  .component("tagsPage", tags)
  .service("TagsTransforms", TagsTransforms)
  .config(tagsUrls);

export default tagsModule;



// WEBPACK FOOTER //
// ./src/pages/tags/tags.module.js